import React, {useContext} from "react";

import {NavLink, Link} from "react-router-dom";
import pageList from './pageList';
import Request, {CODES} from '../../utils/Request';

import UserContext from '../../utils/UserContext';

import {RMA} from '../../utils/svgs';


class pageListOrderEntry extends pageList {
	
	constructor(props){
		super(props)

		this.entryEncoded = this.props.match.params.entryEncoded;
		let entryDecoded = JSON.parse(atob(this.entryEncoded));
		this.date = entryDecoded.date;
		this.invoice = entryDecoded.invoice;
		this.provider = entryDecoded.provider;

		this.responseField = 'products';
		this.apiName = 'orders-entry/'+this.entryEncoded;
		this.listSlug = 'orders';
		this.singleItem = 'pedido'; //Name of a single list item
		this.listTitle = 'Factura de entrada: '+this.invoice;
		this.listSubTitle = `Proveedor: ${this.provider}
		Fecha: ${this.date}`;

		this.hasRowOptions = false;
		this.listWithoutLinks = true;
		// this.itemLinkSlug = 'item';

	}
	
	componentDidMount(){
		this.requestPages();
	}

	getTable(pages){
		let table = {};
		table.headers = [
			{
				slug: 'quantity',
				name: 'Cantidad',
				class: 'item-small',
			},
			{
				slug: 'sku',
				name: 'SKU',
				class: 'item-medium',
				canSearch: true,
			},
			{
				slug: 'bar_code',
				name: 'Código de barras',
				class: 'item-medium',
				canSearch: true,
			},
			{
				slug: 'serial_number',
				name: 'Número Serie',
				class: 'item-extra-big',
				canSearch: true,
			},
		];
		table.rows = [];
		for(let i = 0; i < pages.length; i++){
			table.rows.push(this.createRow(pages[i]));
		}
		return table;
	}

	createRow(page){
		return {
			item : page,
			id : page.id,
			quantity : page.quantity,
			sku : page.sku,
			serial_number : page.serial_numbers.join(", "),
			provider_bought : page.provider_bought,
			invoice_bought : page.invoice_bought,
			bar_code : page.bar_code,
		};
	}

	renderAddNew(){
		return <Link to={'/add-stock/?invoice='+this.invoice+'&date='+this.date+'&provider='+this.provider} className="button button-default font-p font-white font-center">Añadir más productos</Link>;
	}
}





export default pageListOrderEntry;




